'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { ExamplesSectionCardModel } from '../../types'

type Props = { props: ExamplesSectionCardModel }

const ExampleSectionCard = ({
  props: {
    subHeader,
    header,
    description,
    exampleUser,
    exampleUserDescription,
    exampleUserImage,
    exampleUserFinancialRecords,
  },
}: Props) => {
  const translate = useTranslate()

  return (
    <article className="secondhand-taxes__examples-card">
      <div className="secondhand-taxes__examples-card-infobox">
        <div className="secondhand-taxes__examples-card-infobox-header">
          <div className="secondhand-taxes__examples-card-infobox-header-user">
            <p className="secondhand-taxes__examples-card-infobox-header-name">
              {translate(exampleUser)}
            </p>
            <p className="secondhand-taxes__examples-card-infobox-header-description">
              {translate(exampleUserDescription)}
            </p>
          </div>
          <div className="secondhand-taxes__examples-card-infobox-header-image">
            <Image
              src={exampleUserImage.src}
              srcset={exampleUserImage.srcSet}
              scaling="cover"
              loading="lazy"
              alt={exampleUser}
            />
          </div>
        </div>
        {exampleUserFinancialRecords.map((record, index) => (
          <div className="secondhand-taxes__examples-card-infobox-row" key={index}>
            <span className="secondhand-taxes__examples-card-infobox-row-title">
              {translate(record.key)}
            </span>
            <span className="secondhand-taxes__examples-card-infobox-row-value">
              {translate(record.value)}
            </span>
          </div>
        ))}
      </div>
      <div className="secondhand-taxes__examples-card-notes">
        <p className="secondhand-taxes__examples-card-notes-sub_header">{translate(subHeader)}</p>
        <p className="secondhand-taxes__examples-card-notes-header">{translate(header)}</p>
        <p className="secondhand-taxes__examples-card-notes-description">
          {translate(description)}
        </p>
      </div>
    </article>
  )
}

export default ExampleSectionCard
